import * as React from "react"

const Toast = ({ children, open, onOpenChange }) => {
  if (!open) return null;

  return (
    <div className="fixed bottom-4 right-4 z-50">
      <div className="bg-white rounded-lg shadow-lg p-4">
        {children}
      </div>
    </div>
  );
};

export { Toast }